import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Save, AlertTriangle } from "lucide-react";

const DEFAULTS = { ga4_id: "", gtm_id: "", meta_pixel_id: "", tiktok_pixel_id: "", linkedin_partner_id: "", hotjar_id: "", clarity_id: "", custom_head_html: "", custom_body_html: "" };

export default function AnalyticsPage() {
  const [data, setData] = useState(DEFAULTS);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/content/kv/analytics").then(({data:v}) => v && setData({...DEFAULTS, ...v})); }, []);
  const upd = (k, v) => setData(s => ({...s, [k]: v}));
  const save = async () => {
    setSaving(true);
    try { await api.put("/content/kv/analytics", { value: data }); toast.success("Analytics salvo. Os scripts serão injetados no próximo carregamento da página pública."); }
    catch { toast.error("Erro ao salvar."); }
    finally { setSaving(false); }
  };

  const fields = [
    { k: "ga4_id", l: "Google Analytics 4 (GA4) Measurement ID", ph: "G-XXXXXXXXXX" },
    { k: "gtm_id", l: "Google Tag Manager ID", ph: "GTM-XXXXXXX" },
    { k: "meta_pixel_id", l: "Meta (Facebook) Pixel ID", ph: "1234567890" },
    { k: "tiktok_pixel_id", l: "TikTok Pixel ID", ph: "CXXXXXXX" },
    { k: "linkedin_partner_id", l: "LinkedIn Insight Partner ID", ph: "1234567" },
    { k: "hotjar_id", l: "Hotjar Site ID", ph: "1234567" },
    { k: "clarity_id", l: "Microsoft Clarity ID", ph: "abc123def" },
  ];

  return (
    <div>
      <div className="flex justify-between items-end mb-6">
        <div><h1 className="font-display text-4xl">Analytics & Pixels</h1><p className="text-sm text-neutral-500 mt-1">Conecte ferramentas de medição e conversão. Os scripts são carregados automaticamente.</p></div>
        <button onClick={save} disabled={saving} data-testid="analytics-save" className="bg-black text-white text-sm px-5 py-2.5 rounded-full hover:bg-accent-orange disabled:opacity-50"><Save className="w-3 h-3 inline mr-1" /> {saving ? "Salvando…" : "Salvar"}</button>
      </div>

      <div className="grid md:grid-cols-2 gap-3">
        {fields.map(f => (
          <div key={f.k} className="border border-black/10 p-4 rounded">
            <label className="text-xs text-neutral-500">{f.l}</label>
            <input value={data[f.k]} onChange={(e) => upd(f.k, e.target.value)} placeholder={f.ph} className="w-full border border-black/15 px-3 py-2 rounded text-sm font-mono mt-1" data-testid={`analytics-${f.k}`} />
            <div className="text-[10px] text-neutral-400 mt-1">Deixe em branco para desativar.</div>
          </div>
        ))}
      </div>

      <div className="mt-8 border border-amber-300 bg-amber-50 p-4 rounded text-xs text-amber-900 flex gap-2"><AlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5" /><div>Os campos abaixo permitem inserir HTML/JS bruto. Use somente com conteúdo de fonte confiável. Use para tags do Google Search Console, scripts customizados, chat widgets, etc.</div></div>

      <div className="mt-4 grid md:grid-cols-2 gap-3">
        <div>
          <label className="text-xs text-neutral-500">HTML/Script no &lt;head&gt;</label>
          <textarea value={data.custom_head_html} onChange={(e) => upd("custom_head_html", e.target.value)} rows={6} className="w-full border border-black/15 px-3 py-2 rounded text-sm font-mono" placeholder="<meta name='facebook-domain-verification' ...>" data-testid="analytics-custom-head" />
        </div>
        <div>
          <label className="text-xs text-neutral-500">HTML/Script no fim do &lt;body&gt;</label>
          <textarea value={data.custom_body_html} onChange={(e) => upd("custom_body_html", e.target.value)} rows={6} className="w-full border border-black/15 px-3 py-2 rounded text-sm font-mono" placeholder="<!-- chat widget, etc -->" data-testid="analytics-custom-body" />
        </div>
      </div>

      <div className="mt-8 text-xs text-neutral-500">Eventos que disparam automaticamente quando configurados: <code className="bg-black/5 px-1">PageView</code>. Para eventos customizados (Lead, Contact, etc.) chame <code className="bg-black/5 px-1">trackEvent('Lead', {`{...}`})</code> no código.</div>
    </div>
  );
}
